import React , {useState} from 'react'
import '../CSS/style.css'
import '../CSS/responsive.css'

var queslists = [];  

export default function QuesSolTemplate(props) {
  
const [currentPage, setCurrentPage] = useState(1);


  var pages = [];
  // console.log(questions);
  var ques = Object.values(props.questions)
  var sol = Object.values(props.solutions);
  var output = Object.values(props.output);
  var ques1 = [] , sol1 = [] , output1 = [] ;
  // console.log(ques)
  // var queslists = [] ;
  var DataPerPage = 5 ;
  // var currentPage = 1 ;
  var maxPages = Math.ceil(ques.length/DataPerPage) ;
  // console.log(maxPages)
  var endNumber = DataPerPage  ;
  var startNumber = 0 ;
  for(let i = 1 ; i <= maxPages ; i++ ){
    pages[i] = i;
  }
 
  // const  handleOnClk = (page) =>{
  //   setCurrentPage(page);
  //   showData();
  // }
  

  const handlePrevClick = ()=>{
    // dispData(event.target.id);
    if(currentPage !== 1){
    setCurrentPage(currentPage - 1);
    
    }
    showData();
  }
  const hadnleNextClick = ()=>{
    if(currentPage !== maxPages){
    setCurrentPage(currentPage + 1);
    
    }
    showData();
  }

  
  endNumber = currentPage * DataPerPage;

  startNumber = (currentPage-1) * DataPerPage ; 
  
const showData=()=>{
  
  ques1 = ques.slice(startNumber , endNumber);
  sol1 = sol.slice(startNumber , endNumber);
  output1 = output.slice(startNumber , endNumber);
  if(ques.length !== 0){
    
    queslists = (ques1.map((myQues , index)=>
    
    <div key={index} className='mt-25 mb-25'>
    
      <div className='questions sec-heading font-baloo' >Q{(startNumber+++1)}. {myQues}</div>
    
        <div className="programs">
          <div className="sec-heading color-blue ">Program:</div>
      <div className='program m-auto' dangerouslySetInnerHTML={{__html: sol1[index]}}></div></div>
      <div className="outputs">
        <div className="sec-heading color-blue ">Output:</div>
      <div className="program m-auto" dangerouslySetInnerHTML={{__html: output1[index]}}></div></div>
      {/* <div className='text-center'><button className="submitbtn runbtn">Run Code</button></div> */}
    </div>
  
    )
  )
      
  
  }
  else{
    queslists = (<div className='m-auto p-heading'>No Programmes found.</div>)
  }
  // console.log(queslists)
  }
showData();
 return (
    <div>
    {queslists}
    {/* {ques.length !== 0 ? 
    
    <ul className='pages'> Pages :
      {pages.map((page , index)=>
      <li key={page} id={page} className={page === currentPage ? 'active' : ""} onClick={()=>handleOnClk(page)}>{page}</li>
      )}
    </ul>
    : "" } */}
    <div className="buttons m-auto flex-nav-button ">
      
      <button className="submitbtn navigationBtn" id={currentPage === 1 ? 'Disabled' : ''} onClick={handlePrevClick} >Prev</button>
      <button className="submitbtn navigationBtn" id={currentPage === maxPages ? 'Disabled' : ''} onClick={hadnleNextClick} >Next</button>
      
      </div>
    </div>
  )
  };